import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { get } from 'lodash';
import React, { FC } from 'react';
import { EINREICHUNG_DER_UNTERLAGEN } from 'src/lib/constants/constant';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const PostVersandInfoDeminimis: FC<{ application: string }> = ({ application }) => {
	const EinreichungDerUnterlagen = get(application, P.Foerderprogramm.schema.attributes.Konfiguration_Einreichung_Der_Antragsunterlagen.path, '');

	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.postalisch) {
		return (
			<>
				<Divider sx={{ borderColor: '#000', mt: '2rem' }} />
				<Stack spacing={3} sx={{ mt: '1rem' }}>
					<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
						Einreichung der De-minimis-Erklärung
					</Typography>
					<Typography>
						Die De-minimis-Erklärung ist Bestandteil des Förderantrags. Bitte lassen Sie uns diese - zusammen mit den weiteren Antragsdokumenten
						- fristgerecht im Original zukommen. <br></br>Weitere Informationen finden Sie im Menüpunkt "Antragseinreichung".
					</Typography>
					<Box sx={{ mb: '5rem !important' }}>{/*Platzhalter element*/}</Box>
				</Stack>
			</>
		);
	} else {
		return <></>;
	}
};
export default PostVersandInfoDeminimis;
